var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-txt"},[_c('p',[_vm._t("btn")],2),_c('p',[_vm._v(_vm._s(_vm.description)+"规格："+_vm._s(_vm.width)+"×"+_vm._s(_vm.height))]),_c('p',[_vm._v(_vm._s(_vm.description)+"大小："+_vm._s(_vm._f("smartSize")(_vm.file_size)))]),_c('p',[_vm._v("支持类型："+_vm._s(_vm._f("formatType")(_vm.file_format)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }